import React from "react";
import { useTranslation } from "react-i18next";

import "antd/dist/antd.css";

import "./style.css";
import { ItemCertificados } from "../UI/ItemCertificados";

export const Certificados = () => {
	const [t] = useTranslation("global");
	const data = [
		{
			picture:
				"https://res.cloudinary.com/devsing/image/upload/v1654288803/Portfolio/688_jkjznd.png",
			fecha: "Nov-2020",
			nombre: "Hackathon Nicaragua",
			evento: t("hack_n"),
		},
		{
			picture:
				"https://res.cloudinary.com/devsing/image/upload/v1654288824/Portfolio/img012_aq64np.jpg",
			fecha: "Oct-2020",
			nombre: t("rally_t"),
			evento: t("rally_02"),
		},
		{
			picture:
				"https://res.cloudinary.com/devsing/image/upload/v1654288825/Portfolio/KEVIN-01_a0royx.png",
			fecha: "Jun-2021",
			nombre: t("cet_ag"),
			evento: t("cert_met"),
			show: true,
		},
		{
			picture:
				"https://res.cloudinary.com/devsing/image/upload/v1654288796/Portfolio/photo_2022-04-29_15-37-31_ffmebs.jpg",
			fecha: "oct-2020",
			nombre: "Rally",
			evento: t("rally_03"),
		},
		{
			picture:
				"https://res.cloudinary.com/devsing/image/upload/v1654288820/Portfolio/img013_kicsun.jpg",
			fecha: "oct-2020",
			nombre: "Rally",
			evento: t("rally_03"),
		},
	];

	return (
		<>
			<br />
			<br />

			<div className="select-none flex flex-col justify-center items-center my-8 w-screen bg-gray-900 relative overflow-hidden">
				<br />
				<br />
				<br />
				<h2 className="text-center text-yellow-300 font-Montserrat font-bold text-2xl">
					{t("Acknowledgments")}
				</h2>

				<div className="contact-info overflow-hidden">
					<div className="grid grid-cols-1 mx-2  laptop:grid-cols-2 laptop:w-96/0 laptop:mx-10 justify-between items-center contact-info2 overflow-hidden">
						{data.map((item, index) => (
							<div key={index}>
								<ItemCertificados index={index} item={item} />
							</div>
						))}
					</div>
				</div>
				<br />
				<br />
				<br />
			</div>
		</>
	);
};
